import React, { Fragment } from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { calendarIntegrationUtils } from '../utils/utils';
import { CALENDAR_PROVIDERS } from '../PersonalCalendars/calendarProviders';
import { BsArrowBarRight } from 'react-icons/bs';

const ExternalCalendarEventViewControl = React.memo(({ event = {}, showCalendarIcon = true, textMode = false }) => {
    const provider = CALENDAR_PROVIDERS[event?.calendarProvider];
    const calendarProvider = event?.calendarProvider || '';
    const htmlLink = event?.htmlLink || '';
    const text = `Open ${calendarIntegrationUtils.formatProviderName(calendarProvider)} Event`;
    if (!event?.htmlLink) return null;

    return (
        <BootstrapToolTip text={text}>
            <a href={htmlLink} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block' }}>
                <div style={{ flex: 1, minWidth: '120px' }}>
                    {textMode ? (
                        <Fragment>
                            <div className=" align-items-center d-flex flex-row mt-4">
                                <div className="mr-2">{text} Link</div>
                                <div>
                                    <FiExternalLink />
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <Fragment>
                            {showCalendarIcon && <Fragment>{provider?.icon}</Fragment>}
                            <BsArrowBarRight size={40} className="text-primary" />
                        </Fragment>
                    )}
                </div>
            </a>
        </BootstrapToolTip>
    );
});

export default ExternalCalendarEventViewControl;
